<template>
  <default>
    <div class="cust-motor-wrap">
      <motor-apply-page />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import MotorApplyPage from '@/components/motor/MotorApplyPage';

export default {
  name: 'CustomerMotorApply',
  components: { Default, MotorApplyPage },
  metaInfo: { title: 'Motor insurance — Application' },
};
</script>

<style src="@/assets/css/customer-motor.css"></style>
